export const getLocalStorageItem = (key: string) => {
  try {
    const serializedObject = localStorage.getItem(key);
    if (serializedObject === null) {
      return undefined;
    }
    return JSON.parse(serializedObject); // Analisa o JSON e retorna o objeto
  } catch (error) {
    console.error(`Erro ao recuperar objeto ${key} do localStorage:`, error);
    return undefined;
  }
};
